import React, { useEffect } from 'react';
const HubspotForm = ({ scriptSrc, formId }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = scriptSrc;
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: 'na1',
          portalId: '6129878',
          formId: formId,
          target: '#hubspotForm',
        });
      }
    });


    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      <div id="hubspotForm"></div>
    </div>
  );
};

export default HubspotForm;
